import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor() { }

  async downloadFiles(urls: string[]): Promise<void> {
    const downloadPromises = urls.map(url => {
      return new Promise<void>((resolve, reject) => {
        const fileName = this.extractFileName(url);

        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.style.display = 'none'; // Ensure the link is not visible
            document.body.appendChild(link); // Append the link to the body
            link.click();
            document.body.removeChild(link); // Remove the link after download
            URL.revokeObjectURL(link.href); // Revoke the object URL
            resolve();
          })
          .catch(error => {
            console.error('Error fetching file:', error);
            reject();
          });
      });
    });

    await Promise.all(downloadPromises);
  }

  extractFileName(url: string): string {
    return url.split('/').pop() || 'unknown';
  }
}
